
export default {
    name: 'FeaturedGame',
}
